import axios from "axios";
import { apiUrl, PORT } from "../../environment";
import { toast } from "react-toastify";
import axiosClient from "./axiosClient";

/**
 * @description registration in db.
 * @param {*} data
 * @param {*} callback
 */

export const registration = (data, callback, dispatch) => {
  try {
    return axiosClient
      .post(`/user-service/create-provider`, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  } catch (err) {
  }
};
export const getProviders = async (params, callback, dispatch) => {
  try {
    const response = await axiosClient.get(`/user-service/get-providers`, {
      params,
    });

    if (response?.status === "SUCCESS") {
      callback(response.data);
    } else {
      callback(false);
    }
  } catch (error) {
    callback(false);
  }
};

export const getMedia = async (params, callback) => {
  try {

    const response = await axiosClient.get(`/user-service/media-for-provider`, {
      params,
    });

    if (response?.status === "SUCCESS") {
      callback(response.data);
    } else {
      toast.error(response.message);
      callback(false);
    }
  } catch (err) {
    toast.error("An error occurred while fetching media.");
    callback(false);
  }
};

export const getSingleProvider = async (userId) => {
  try {
    const response = await axiosClient.get(`/user-service/get-provider`, {
      params: { userId },
    });

    if (response?.status === "SUCCESS") {
      return response?.data;
    }
  } catch (error) {
    toast.error("An error occurred while fetching provider details.");
  }
};

export const deleteProvider = async (param) => {
  try {
    const response = await axiosClient.put(
      `/user-service/delete-provider`,
      {},
      {
        params: { userId: param },
      }
    );

    if (response?.status === "SUCCESS") {
      toast.success("Provider deleted successfully");
      return response?.data;
    } else {
      toast.error(response?.data?.message || "Failed to delete provider");
    }
  } catch (error) {
    if (error.response && error.response.status === 204) {
      toast.success("Provider deleted successfully (no content)");
      return { status: "SUCCESS" };
    }

    toast.error("Failed to delete provider");
    return error;
  }
};

export const changePassword = async (data, token) => {
  try {
    let userToken = token ? token : "";
    if (userToken) {
      let option = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      let response = await axios.put(
        `${apiUrl}${PORT}/auth-service/change-password`,
        data,
        option
      );

      if (response?.data?.status === "SUCCESS") {
        toast.success(response?.data?.message);
        return response;
      } else {
        toast.error(response?.data?.message);
      }
    }
  } catch (error) {
    if (error.response?.data?.details) {
      // const errorMessages = error.response.data.details.map(detail => {
      //   return `${detail.message}`;
      // }).join('\n');

      const errorMessages = error.response.data.details[0].message;

      toast.error(
        errorMessages || "An error occurred while changing password."
      );
    } else {
      toast.error(
        error.response?.data?.error ||
        "An error occurred while changing password."
      );
    }
  }
};

export const editDoctor = (data, provider) => {
  try {
    return axiosClient
      .post(`/user-service/update-provider?userId=${provider}`, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  } catch (err) {
  }
};

export const addMedia = async (data, callback, dispatch) => {
  try {
    return await axiosClient
      .post(`/user-service/media`, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  } catch (err) {
  }
};

export const updateMedia = async (data, media_id, callback, dispatch) => {
  try {
    return await axiosClient
      .put(`/user-service/media/${media_id}`, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  } catch (err) {
  }
};

export const deleteMediaImageFromDB = (data, index, callback, dispatch) => {
  try {
    return axios
      .put(`${apiUrl}${PORT}/user-service/media/${data._id}/deleteImage`, {
        data,
        index,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  } catch (err) {
  }
};
/**
 * @description contactUs in db.
 * @param {*} data
 * @param {*} callback
 */

// ****************************Survey Management Api *************************************************************************

// Get all surveys
export const getSurves = async (params = {}) => {
  try {
    const response = await axiosClient.get("/user-service/fetch-all-survey", {
      params,
    });

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching surveys");
  }
};

// Get survey responses by patient ID
export const getResponseSurvesByPatient = async (params = {}) => {
  try {
    const response = await axiosClient.get(
      `/user-service/responses-by-patientid/${params.patient}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching surveys");
  }
};

export const createSurvey = async (data) => {
  try {
    const response = await axiosClient.post(
      `/user-service/create-survey`,
      data
    );

    if (response?.status === "SUCCESS") {
      toast.success(response.message);
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while creating the survey");
  }
};

//updatte survey
export const updateSurvey = async (data) => {
  try {
    const response = await axiosClient.put(
      `/user-service/update-survey/${data._id}`,
      data
    );

    if (response?.status === "SUCCESS") {
      return response; // Returning data if needed
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while updating the survey");
  }
};

// Add a new question to a survey
export const addQuestion = async (data) => {
  try {
    const response = await axiosClient.post(`/user-service/add-question`, data);

    if (response?.status === "SUCCESS") {
      toast.success("Question Added Successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while adding the question");
  }
};

// update question
export const updateQuestion = async (data) => {
  try {
    const response = await axiosClient.put(
      `/user-service/update-question/${data._id}`,
      data
    );

    if (response?.status === "SUCCESS") {
      toast.success("Question updated successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while updating the question");
  }
};

// Fetch survey questions
export const getQuestions = async (params) => {
  try {
    const response = await axiosClient.get(
      `/user-service/fetch-survey-questions/${params.surveyId}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching questions");
  }
};
// create survey
// export const deleteSurvey = async (token, data) => {
//   try {
//     if (token) {
//       const options = {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       };

//       const response = await axios.put(
//         `${apiUrl}${PORT}/user-service/update-survey/${data._id}`, data ,
//           options
//       );

//       // Check the response status
//       if (response?.data?.status === "SUCCESS") {
//         return response.data; // Returning data if needed
//       } else {
//         toast.error(response.data.message);
//       }
//     } else {
//       toast.error("Auth Error");
//     }
//   } catch (err) {
//     toast.error("An error occurred while fetching patients");
//   }
// };

// Get community topic list
export const getComunityTopicList = async (params) => {
  try {
    const response = await axiosClient.get("/user-service/topics", { params });

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching topics.");
  }
};

// Create a new topic (supports FormData for file uploads)
export const createTopic = async (data) => {
  try {
    const response = await axiosClient.post("/user-service/topics", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response?.status === "SUCCESS") {
      toast.success("Topic created successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while creating the topic.");
  }
};

// Update an existing topic (supports FormData for file uploads)
export const updateTopic = async (data, _id) => {
  try {
    const response = await axiosClient.put(
      `/user-service/topics/${_id}`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    if (response?.status === "SUCCESS") {
      toast.success("Topic updated successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while updating the topic.");
  }
};

// Delete a topic
export const deleteTopic = async (data) => {
  try {
    const response = await axiosClient.patch(
      `/user-service/topics/${data._id}`,
      data
    );

    if (response?.status === "SUCCESS") {
      toast.success("Topic deleted successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while deleting the topic.");
  }
};

// Get topic community by ID (Handles both Provider & Patient Forums)

export const getTopicCommunityById = async (params, forumCategory) => {
  try {
    let endpoint;
    forumCategory === "All-Record"
      ? (endpoint =
        params.category === "Provider-Forum"
          ? "/user-service/posts"
          : "/patient-service/posts")
      : (endpoint =
        forumCategory === "Provider-Forum"
          ? "/user-service/posts"
          : "/patient-service/posts");

    const response = await axiosClient.get(endpoint, { params });

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching community topics.");
  }
};

// Create a new post
export const createPost = async (data, community, forumCategory) => {
  try {
    let endpoint;
    forumCategory === "All-Record"
      ? (endpoint =
        community.category === "Provider-Forum"
          ? "/user-service/posts"
          : "/patient-service/posts")
      : (endpoint =
        forumCategory === "Provider-Forum"
          ? "/user-service/posts"
          : "/patient-service/posts");

    const response = await axiosClient.post(endpoint, data);

    if (response?.status === "SUCCESS") {
      // toast.success("Post created successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while creating the post.");
  }
};

// Update an existing post (Handles both Provider & Patient Forums)
export const updatePost = async (
  post,
  data,
  forumCategory,
  actionType = null
) => {
  try {
    // const endpoint =
    //   forumCategory === "Provider-Forum"
    //     ? `/user-service/posts/${post.id}`
    //     : `/patient-service/posts/${post.id}`;

    let endpoint;
    forumCategory === "All-Record"
      ? (endpoint =
        post?.topicDetails?.category === "Provider-Forum"
          ? `/user-service/posts/${post._id}`
          : `/patient-service/posts/${post._id}`)
      : (endpoint =
        forumCategory === "Provider-Forum"
          ? `/user-service/posts/${post._id}`
          : `/patient-service/posts/${post._id}`);

    const response = await axiosClient.put(endpoint, data);
    if (data?.upvotes) {
      return response;
    }
    if (response?.status === "SUCCESS") {
      if (actionType === "post_delete") {
        toast.success("Post deleted successfully");
      } else {
        toast.success("Post updated successfully");
      }
      // toast.success("Post updated successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while updating the post.");
  }
};

// Get comments by post ID
export const getCommentsByPost = async (id, params = {}) => {
  try {
    const response = await axiosClient.get(
      `/user-service/coments-by-post/${id}`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching comments.");
  }
};

// Disable a Provider/Doctor
export const ProviderDisabled = async (data) => {
  try {
    const response = await axiosClient.post(
      `/user-service/update-provider`,
      data,
      { params: { userId: data?.userId } }
    );

    if (response?.status === "SUCCESS") {
      toast.success("Provider/Doctor Disabled successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while disabling the provider.");
  }
};

// Disable a Patient
export const PatientDisabled = async (data) => {
  try {
    const response = await axiosClient.put(
      "/patient-service/update-patient",
      data,
      { params: { patientId: data?.patientId } }
    );

    if (response?.status === "SUCCESS") {
      toast.success("Patient Disabled successfully");
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while disabling the patient.");
  }
};

// Get patients assigned to a provider
export const getPatientByProviderId = async (params = {}) => {
  try {
    const response = await axiosClient.get(
      "/patient-service/get-unassigned-patientlist",
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching patients.");
  }
};

export const getAllPatientForAdmin = async (params = {}) => {
  try {
    const response = await axiosClient.get(
      "/patient-service/get-unassigned-patientlist",
      { params }
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching patients.");
  }
};

export const assignSurvey = async (data) => {
  try {
    const response = await axiosClient.post(
      "/user-service/assign-survey",
      data
    );

    if (response?.status === "SUCCESS") {
      toast.success(response.message);
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while assigning the survey.");
  }
};

// Assign a survey to all patients
export const assignSurveyToAllPatient = async (data) => {
  try {
    const response = await axiosClient.post(
      "/user-service/assign-survey-for-all-patient",
      data
    );

    if (response?.status === "SUCCESS") {
      toast.success(response.message);
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error(
      "An error occurred while assigning the survey to all patients."
    );
  }
};

//***************************** CATEGORY RELATED LOGIC (NEW CONCEPT BY CLIENT) ***************************************************************** */
export const getCategory = async (params, callback) => {
  try {

    const response = await axiosClient.get(`/user-service/main-category`, {
      params,
    });

    if (response?.status == "SUCCESS") {
      callback(response.data);
    } else {
      toast.error(response.message);
      callback(false);
    }
  } catch (err) {
    toast.error("An error occurred while fetching media.");
    callback(false);
  }
};

export const createCategory = async (data) => {
  try {
    const response = await axiosClient.post(
      `/user-service/main-category`,
      data
    );

    if (response?.status == "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
      return null;
    }
  } catch (err) {
    toast.error("An error occurred while fetching category.");
  }
};

export const updateCategory = async (id, data) => {
  try {
    const response = await axiosClient.put(
      `/user-service/main-category/${id}`,
      data
    );

    if (response?.status == "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching category.");
  }
};

export const deleteCategory = async (id) => {
  try {
    const response = await axiosClient.delete(
      `/user-service/main-category/${id}`
    );

    if (response?.status == "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching category.");
  }
};

//*****************************SUB CATEGORY RELATED LOGIC ***************************************************************** */

// fetch all subcategory of that specific catgeory
export const fetchSubCategoryOfCategory = async (params) => {
  try {
    const response = await axiosClient.get(`/user-service/get-sub-category`, {
      params,
    });

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching category.");
  }
};
// to get all subcategory irespective of category
export const getSubCategory = async (params, callback) => {
  try {

    const response = await axiosClient.get(
      `/user-service/get-allsub-category`,
      { params }
    );

    if (response?.status === "SUCCESS") {
      callback(response.data);
    } else {
      toast.error(response.message);
      callback(false);
    }
  } catch (err) {
    toast.error("An error occurred while fetching media.");
    callback(false);
  }
};

export const createSubCategory = async (data) => {
  try {
    const response = await axiosClient.post(
      `/user-service/learning-category`,
      data
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching category.");
  }
};

export const updateSubCategory = async (id, data) => {
  try {
    const response = await axiosClient.put(
      `/user-service/learning-category/${id}`,
      data
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching category.");
  }
};

export const deleteSubCategory = async (id) => {
  try {
    const response = await axiosClient.delete(
      `/user-service/learning-category/${id}`
    );

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching category.");
  }
};

// get reported post for patients
export const getReportedPost = async (params) => {
  try {
    const response = await axiosClient.get("/patient-service/posts-reported", {
      params,
    });

    if (response?.status === "SUCCESS") {
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching topics.");
  }
};

export const handleDisablePost = async (data) => {
  try {
    const response = await axiosClient.put(
      "/patient-service/posts-desabled",
      data
    );

    if (response?.status === "SUCCESS") {
      toast.success(response.message);
      return response;
    } else {
      toast.error(response.message);
    }
  } catch (err) {
    toast.error("An error occurred while fetching topics.");
  }
};

export const checkInviteCode = async (inviteCode, provider = null) => {
  try {
    const response = await axiosClient.get(
      `/user-service/check-invite-code?inviteCode=${inviteCode}&providerId=${provider}`
    );

    if (response?.status === "SUCCESS") {
      return response.data;
    } else {
      toast.error(response.message);
      return null;
    }
  } catch (err) {
    toast.error("An error occurred while checking the invite code.");
  }
};

const ProviderService = {
  registration,
  getProviders,
  getSingleProvider,
  changePassword,
  editDoctor,
  addMedia,
  updateMedia,
  deleteMediaImageFromDB,
  getSurves,
  addQuestion,
  checkInviteCode
};

export default ProviderService;
